exports.buildImagePath = function (imageName) {
  return '/web-2/assets/images/' + imageName;
};
